module.exports = __webpack_public_path__ + "static/img/satanizador-3.6397483.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/satanizador-3.jpg
// module id = 1iLF
// module chunks = 1